import * as Sentry from '@sentry/vue';

import { Auth } from '@core/auth';

import config from '@/config';

const setSentryScope = async (to, from, next) => {
    const auth = Auth();

    if (!config.SENTRY_DSN) {
        next();
        return;
    }

    if (auth.id) {
        Sentry.setUser({
            id: auth.user_id,
            email: auth.user_email,
            name: auth.user_name,
            gi_ref: auth.gi_ref,
            organisation_id: auth.organisation_id,
            organisation_type: auth.organisation_type,
            organisation_roles: auth.organisation_roles,
            is_gi: auth.is_gi
        });
    } else {
        Sentry.setUser(null);
    }

    next();
};

export default setSentryScope;
